import React from 'react';
import { Container } from 'library';

import { COMPARISON_TABLE_DATA, MOBILE_COLUMNS } from '../../../constants/comparisonTableData';
import BaseTable from '../BaseTable/BaseTable';
import TableSectionWrapper from '../TableSectionWrapper/TableSectionWrapper';

const PricingTable = () => {
  return (
    <TableSectionWrapper theme="plain">
      <Container row justify="center" className="TableSectionHeading">
        <Container grid={8}>
          <h3>Pricing & terms</h3>
          <p>( Example based on home value of $1 million )</p>
        </Container>
      </Container>
      <BaseTable data={COMPARISON_TABLE_DATA.pricing} mobileColumns={MOBILE_COLUMNS.pricing} />
      <p className="align-left text-body-sm text-gray">
        <em>
          <sup>*</sup>Loan interest levels and payments are based on a credit score of 730. Rates sourced from 2020
          Bankrate.com data
        </em>
      </p>
    </TableSectionWrapper>
  );
};

export default PricingTable;
